import React, { useState,useEffect, useRef } from "react";
import { Html, Text } from "@react-three/drei";
import { OverlayTrigger, Popover } from "react-bootstrap";

export default function LeftGlobe(props) {
  const mesh = useRef();
  //const textRef = useRef();
  const [hovered, setHovered] = useState(false);
  useEffect(() => {
    document.body.style.cursor = hovered ? 'pointer' : 'auto';
  }, [hovered]);

  const popover = (
    <Popover id="popover-basic" className="mini-globe-popup globe-satellite-popup">
      <div className="globe-popup-body">
        <div className="popup-content-wrapper">
          <div className="connecting-line"></div>
          <div className="mg-text-wrapper">
            <div className="mini-globe-text">Connect with Mission Directors</div>
          </div>
        </div>
      </div>
    </Popover>
  );
  return (
    <group ref={mesh} position={props.position}>
      <mesh        
        onPointerOver={(event) => {
          console.log(event);
          setHovered(true);
        }}
        onPointerOut={(event) => {
          console.log(event);
          setHovered(false);
        }}
      >
        <Html zIndexRange ={[0, 0]}>
          <div className="left-right-globe-position">
          <div onClick={props.onclick} className="globe-satellite-outer-ring ">
          <OverlayTrigger
        trigger={["hover", "focus", "click"]}
        placement="left-end"
        overlay={popover}
        rootClose
      >
        <div className="globe-satellite"></div>
      </OverlayTrigger>
          </div>

          </div>
        </Html>
        
      </mesh>
      {/* <mesh onClick={props.onclick}>
        <sphereGeometry args={[0.4, 100, 100]} />
        <meshStandardMaterial
          attach="material"
          color="#00AEFF"
          transparent
          roughness={0}
          metalness={0}
          opacity={0.2}
        />
      </mesh> */}

      {hovered && (
        <mesh position={[0.5, 1.4, 0]}>
          {/* <planeGeometry args={[5, 1]} />
          <meshStandardMaterial
            roughness={0.5}
            color="#005587"
            opacity={0}
            transparent
          /> */}
          {/*  color="#005587" */}
          {/* <Text
            ref={textRef}
            color={"#00AEFF"}
            fontSize={0.3}
            maxWidth={100}
            lineHeight={1}
            letterSpacing={0.02}
            textAlign={"left"}
            position={[0, 0, 0.01]}
            overflowWrap="break-word"
            whiteSpace="overflowWrap"
          >
            Connect with Mission Directors
          </Text> */}
          {/*<Html>
            <div id="popover-basic" className="mini-globe-popup">
              <div className="globe-popup-body">
                <div className="popup-content-wrapper">
                  <div className="connecting-line"></div>
                  <div className="mg-text-wrapper">
                    <div className="mini-globe-text">
                      Connect with Mission Directors
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Html> */}
        </mesh>
      )}
      {hovered && (
        <mesh position={[0, 0, 0]}>
          {/* <ringGeometry attach="geometry" args={[0.5, 0.5 + 0.03, 128]} /> */}         
        </mesh>
      )}
    </group>
  );
}
